import React from "react"
import { useSelector } from "react-redux"

import { StoreType, ProjectFilters } from "client/store"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchProject {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: ProjectFilters
    onFilter: (filters: ProjectFilters) => void
}

const ProjectSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchProject) => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const popupFilters: SearchFilter[] = [
        {
            title: lang.myProjects,
            isActive: filters.owner === userData.userId,
            onAdd: (obj: ProjectFilters) => ({
                ...obj,
                owner: userData.userId,
            }),
            onClose: (obj: ProjectFilters) => ({
                ...obj,
                owner: null,
            }),
        },
    ]

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default ProjectSearch
